/* Zoom viewer: a photo or clip grows out of where it sits into a full-screen
 * viewer (a "zoom" / shared-element transition, as iPhone folders and apps open),
 * and shrinks back into place on close. Used by:
 *
 *  1. AG See It In Action ([data-siax]): tap a clip in the row.
 *  2. AG Product Builder gallery ([data-agzoom-gallery]): tap the main photo, the
 *     main clip or the zoom button. Swiping walks the gallery in its current filter;
 *     on close the gallery shows whatever was last viewed, then the viewer shrinks
 *     back into the main stage.
 *
 * In the viewer: clips play with sound from the moment they were at (mute button),
 * tap to pause; photos show whole. Swipe left or right for next or previous, swipe
 * down, the X or Esc to close. The box takes each item's own shape, fitted to the
 * screen, so nothing is cropped.
 */
(function () {
  'use strict';
  if (window.AGZoom) return;
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ── Viewer (one per page) ────────────────────────────────────────────
  var shade, stage, ui, posterEl, imgEl, video, bar, muteBtn, countEl, closeBtn, hintEl;
  var S = null; // current session: { items, index, origin, onClose }
  var busy = false, rafId = 0, lastFocus = null;
  var sx = null, sy = null, dragY = 0, dragMoved = false, axis = null;

  function build() {
    shade = document.createElement('div'); shade.className = 'ag-siax__shade'; shade.style.display = 'none';
    stage = document.createElement('div'); stage.className = 'ag-siax__stage'; stage.style.display = 'none';
    stage.setAttribute('role', 'dialog'); stage.setAttribute('aria-modal', 'true'); stage.setAttribute('aria-label', 'Media viewer');
    posterEl = document.createElement('img'); posterEl.alt = ''; posterEl.className = 'ag-siax__poster';
    imgEl = document.createElement('img'); imgEl.alt = ''; imgEl.className = 'ag-siax__img';
    video = document.createElement('video');
    video.setAttribute('playsinline', ''); video.setAttribute('loop', ''); video.preload = 'auto';
    stage.appendChild(posterEl); stage.appendChild(imgEl); stage.appendChild(video);
    ui = document.createElement('div'); ui.className = 'ag-siax__ui'; ui.style.display = 'none';
    ui.innerHTML =
      '<span class="ag-siax__count" aria-live="polite"></span>' +
      '<button type="button" class="ag-siax__btn ag-siax__close" aria-label="Close"><svg width="16" height="16" viewBox="0 0 14 14" aria-hidden="true"><path d="M2 2l10 10M12 2L2 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button>' +
      '<button type="button" class="ag-siax__btn ag-siax__mute" aria-label="Mute"><svg class="is-on" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M11 5 6 9H2v6h4l5 4V5z"/><path d="M15.5 8.5a5 5 0 0 1 0 7M19 5a10 10 0 0 1 0 14"/></svg><svg class="is-off" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M11 5 6 9H2v6h4l5 4V5z"/><path d="m23 9-6 6M17 9l6 6"/></svg></button>' +
      '<div class="ag-siax__bar"><span></span></div>' +
      '<div class="ag-siax__hint"></div>';
    document.body.appendChild(shade); document.body.appendChild(stage); document.body.appendChild(ui);
    bar = ui.querySelector('.ag-siax__bar span');
    muteBtn = ui.querySelector('.ag-siax__mute');
    countEl = ui.querySelector('.ag-siax__count');
    closeBtn = ui.querySelector('.ag-siax__close');
    hintEl = ui.querySelector('.ag-siax__hint');
    closeBtn.addEventListener('click', close);
    shade.addEventListener('click', close);
    muteBtn.addEventListener('click', function () {
      video.muted = !video.muted;
      muteBtn.classList.toggle('is-muted', video.muted);
      muteBtn.setAttribute('aria-label', video.muted ? 'Unmute' : 'Mute');
    });
    video.addEventListener('playing', function () { video.classList.add('is-ready'); });
    video.addEventListener('loadedmetadata', function () { if (S && cur().type === 'video') { cur().aspect = video.videoWidth / video.videoHeight; place(fullRect()); } });
    imgEl.addEventListener('load', function () { imgEl.classList.add('is-ready'); if (S && cur().type === 'image' && imgEl.naturalWidth) { cur().aspect = imgEl.naturalWidth / imgEl.naturalHeight; place(fullRect()); } });
    stage.addEventListener('click', function () {
      if (dragMoved || !S || cur().type !== 'video') return;
      if (video.paused) { var p = video.play(); if (p && p.catch) p.catch(function () {}); } else video.pause();
    });
    bindSwipe();
  }

  function cur() { return S.items[S.index]; }

  function originRect(i) {
    var el = S.origin(i);
    if (!el) return null;
    var r = el.getBoundingClientRect();
    if (!r.width || !r.height) return null;
    var rad = parseFloat(getComputedStyle(el).borderTopLeftRadius) || 12;
    return { left: r.left, top: r.top, width: r.width, height: r.height, radius: rad };
  }
  function fullRect() {
    var a = (S && cur().aspect) || (9 / 16);
    var vw = window.innerWidth, vh = window.innerHeight;
    var w = vw, h = w / a;
    if (h > vh) { h = vh; w = h * a; }
    return { left: (vw - w) / 2, top: (vh - h) / 2, width: w, height: h, radius: 0 };
  }
  function place(r) {
    stage.style.left = r.left + 'px'; stage.style.top = r.top + 'px';
    stage.style.width = r.width + 'px'; stage.style.height = r.height + 'px';
    stage.style.borderRadius = r.radius + 'px';
  }
  function kf(r) { return { left: r.left + 'px', top: r.top + 'px', width: r.width + 'px', height: r.height + 'px', borderRadius: r.radius + 'px' }; }

  function show(i, startAt) {
    S.index = i;
    var it = cur();
    stage.classList.toggle('is-image', it.type === 'image');
    posterEl.src = it.poster || '';
    video.classList.remove('is-ready'); imgEl.classList.remove('is-ready');
    video.pause(); video.innerHTML = '';
    if (it.type === 'video') {
      (it.sources || []).forEach(function (s) {
        var el = document.createElement('source'); el.src = s.src; if (s.type) el.type = s.type; video.appendChild(el);
      });
      video.load();
      if (startAt) video.addEventListener('loadedmetadata', function once() { video.removeEventListener('loadedmetadata', once); try { video.currentTime = startAt; } catch (e) {} });
      var p = video.play();
      if (p && p.catch) p.catch(function () { video.muted = true; muteBtn.classList.add('is-muted'); video.play().catch(function () {}); });
      imgEl.removeAttribute('src');
    } else {
      video.load();
      imgEl.src = it.src || it.poster || '';
    }
    muteBtn.style.display = it.type === 'video' ? '' : 'none';
    ui.querySelector('.ag-siax__bar').style.display = it.type === 'video' ? '' : 'none';
    countEl.textContent = S.items.length > 1 ? (i + 1) + ' / ' + S.items.length : '';
    hintEl.textContent = S.items.length > 1 ? 'Swipe for more · swipe down to close' : 'Swipe down to close';
    if (S.onIndex) S.onIndex(i);
  }

  function tick() {
    if (!S) return;
    if (cur().type === 'video' && video.duration) bar.style.width = (video.currentTime / video.duration * 100) + '%';
    rafId = requestAnimationFrame(tick);
  }

  function lock(on) {
    document.documentElement.classList.toggle('ag-siax-noscroll', on);
    document.body.classList.toggle('ag-siax-noscroll', on);
  }

  function open(opts) {
    if (S || busy || !opts.items || !opts.items.length) return;
    if (!stage) build();
    S = { items: opts.items, index: opts.index || 0, origin: opts.origin, onClose: opts.onClose, onIndex: opts.onIndex };
    busy = true;
    lastFocus = document.activeElement;
    video.muted = false; muteBtn.classList.remove('is-muted'); muteBtn.setAttribute('aria-label', 'Mute');
    var from = originRect(S.index);
    if (from && !cur().aspect) cur().aspect = from.width / from.height;
    show(S.index, opts.startAt || 0);
    if (opts.beforeOpen) opts.beforeOpen();
    lock(true);
    var to = fullRect();
    place(to);
    shade.style.display = ''; stage.style.display = ''; ui.style.display = '';
    requestAnimationFrame(function () { shade.classList.add('is-on'); });
    var finished = false;
    var done = function () { if (finished) return; finished = true; busy = false; ui.classList.add('is-on'); closeBtn.focus({ preventScroll: true }); };
    if (!REDUCED && stage.animate && from) {
      var a = stage.animate([kf(from), kf(to)], { duration: 420, easing: 'cubic-bezier(.2,.9,.25,1.05)' });
      a.onfinish = done; setTimeout(done, 600);
    } else {
      if (!REDUCED && stage.animate) stage.animate([{ opacity: 0, transform: 'scale(.94)' }, { opacity: 1, transform: 'none' }], { duration: 250 });
      done();
    }
    document.addEventListener('keydown', onKey, true);
    rafId = requestAnimationFrame(tick);
  }

  function close() {
    if (!S || busy) return;
    busy = true;
    document.removeEventListener('keydown', onKey, true);
    ui.classList.remove('is-on');
    shade.classList.remove('is-on');
    var sess = S;
    // Let the page put the item we ended on into view (gallery stage, clips row).
    if (sess.onClose) { try { sess.onClose(sess.index); } catch (e) {} }
    var from = { left: parseFloat(stage.style.left), top: parseFloat(stage.style.top) + (dragY || 0), width: parseFloat(stage.style.width), height: parseFloat(stage.style.height), radius: 0 };
    stage.style.transform = ''; dragY = 0; shade.style.opacity = '';
    var finished = false;
    var fin = function () {
      if (finished) return; finished = true;
      video.pause(); video.innerHTML = ''; video.load();
      shade.style.display = 'none'; stage.style.display = 'none'; ui.style.display = 'none';
      cancelAnimationFrame(rafId);
      lock(false);
      S = null; busy = false;
      if (sess.afterClose) sess.afterClose();
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    };
    // Measure the target after onClose has had a frame to update the page.
    requestAnimationFrame(function () {
      var to = originRect(sess.index);
      if (!REDUCED && stage.animate && to) {
        var a = stage.animate([kf(from), kf(to)], { duration: 300, easing: 'cubic-bezier(.4,0,.6,1)', fill: 'forwards' });
        a.onfinish = function () { a.cancel(); fin(); };
        setTimeout(function () { a.cancel(); fin(); }, 500);
      } else if (!REDUCED && stage.animate) {
        var b = stage.animate([{ opacity: 1 }, { opacity: 0, transform: 'scale(.94)' }], { duration: 200, fill: 'forwards' });
        b.onfinish = function () { b.cancel(); fin(); };
        setTimeout(function () { b.cancel(); fin(); }, 400);
      } else fin();
    });
  }

  function go(step) {
    if (!S) return;
    var n = S.index + step;
    if (n < 0 || n >= S.items.length) return;
    show(n, 0);
    place(fullRect());
    if (!REDUCED && stage.animate) stage.animate([{ opacity: .3, transform: 'translateX(' + (step * 30) + 'px)' }, { opacity: 1, transform: 'none' }], { duration: 220, easing: 'ease-out' });
  }

  function onKey(e) {
    if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); close(); }
    else if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
    else if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
    else if (e.key === 'Tab') { e.preventDefault(); (document.activeElement === closeBtn && muteBtn.style.display !== 'none' ? muteBtn : closeBtn).focus(); }
  }

  function bindSwipe() {
    stage.addEventListener('touchstart', function (e) {
      sx = e.touches[0].clientX; sy = e.touches[0].clientY; dragY = 0; dragMoved = false; axis = null;
    }, { passive: true });
    stage.addEventListener('touchmove', function (e) {
      if (sx === null) return;
      var dx = e.touches[0].clientX - sx, dy = e.touches[0].clientY - sy;
      if (!axis && (Math.abs(dx) > 8 || Math.abs(dy) > 8)) axis = Math.abs(dy) > Math.abs(dx) ? 'y' : 'x';
      if (axis === 'y' && dy > 0) {
        dragMoved = true; dragY = dy;
        stage.style.transform = 'translateY(' + dy + 'px) scale(' + Math.max(.85, 1 - dy / 1200) + ')';
        shade.style.opacity = String(Math.max(.3, 1 - dy / 500));
      }
      if (axis === 'x') dragMoved = true;
    }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var dx = e.changedTouches[0].clientX - sx;
      sx = null;
      if (axis === 'y') {
        if (dragY > 110) close();
        else { stage.style.transform = ''; shade.style.opacity = ''; dragY = 0; }
      } else if (axis === 'x' && Math.abs(dx) > 50) {
        go(dx < 0 ? 1 : -1);
      }
      setTimeout(function () { dragMoved = false; }, 50);
    });
  }

  window.addEventListener('resize', function () { if (S && !busy) place(fullRect()); });
  window.AGZoom = { open: open, close: close };

  function sourcesOf(videoEl) {
    return Array.prototype.map.call(videoEl.querySelectorAll('source'), function (s) {
      return { src: s.getAttribute('src') || s.getAttribute('data-src'), type: s.getAttribute('type') || '' };
    }).filter(function (s) { return s.src; });
  }

  // ── 1. See It In Action row ─────────────────────────────────────────
  function initRow(root) {
    if (root.getAttribute('data-siax-ready')) return;
    root.setAttribute('data-siax-ready', '1');
    var tiles = Array.prototype.filter.call(root.querySelectorAll('.ag-sia__item'), function (it) {
      return !it.matches('a') && it.querySelector('[data-sia-video]');
    });
    if (!tiles.length) return;
    var track = root.querySelector('[data-sia-track]');
    var mediaOf = function (i) { return tiles[i].querySelector('[data-sia-media]') || tiles[i]; };
    function pauseTiles(on) {
      root.querySelectorAll('[data-sia-video]').forEach(function (v) {
        if (on) { v.setAttribute('data-siax-was', v.paused ? '0' : '1'); v.pause(); }
        else if (v.getAttribute('data-siax-was') === '1') { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      });
    }
    tiles.forEach(function (tile, i) {
      tile.style.cursor = 'pointer';
      tile.addEventListener('click', function (e) {
        e.preventDefault();
        var items = tiles.map(function (t) {
          var v = t.querySelector('[data-sia-video]'), p = t.querySelector('.ag-sia__poster');
          return { type: 'video', sources: sourcesOf(v), poster: p ? (p.currentSrc || p.src) : '', aspect: v.videoWidth ? v.videoWidth / v.videoHeight : 0 };
        });
        var tv = tiles[i].querySelector('[data-sia-video]');
        open({
          items: items, index: i, startAt: tv && tv.currentTime ? tv.currentTime : 0,
          origin: mediaOf,
          beforeOpen: function () { pauseTiles(true); },
          onClose: function (n) {
            if (!track) return;
            var tr = track.getBoundingClientRect(), ir = tiles[n].getBoundingClientRect();
            if (ir.left < tr.left || ir.right > tr.right) track.scrollLeft += ir.left - tr.left - 16;
          },
          afterClose: function () { pauseTiles(false); }
        });
      });
    });
  }

  // ── 2. Product Builder gallery ──────────────────────────────────────
  function initGallery(root) {
    if (root.getAttribute('data-agzoom-ready')) return;
    var stageEl = root.querySelector('[data-agpb-media-stage]');
    if (!stageEl) return;
    root.setAttribute('data-agzoom-ready', '1');
    var photos = {};
    try {
      var mj = JSON.parse((root.querySelector('[data-agpb-media-json]') || {}).textContent || '{}');
      (mj.media || []).forEach(function (m) { photos[String(m.id)] = m; });
    } catch (e) {}
    var clips = {};
    document.querySelectorAll('[data-ag-sia-clips]').forEach(function (s) {
      try { JSON.parse(s.textContent || '[]').forEach(function (c) { clips[String(c.id)] = c; }); } catch (e) {}
    });
    var mainBox = root.querySelector('[data-agpb-media-main]') || stageEl;

    function visibleThumbs() {
      return Array.prototype.filter.call(root.querySelectorAll('[data-agpb-thumb]'), function (t) { return t.style.display !== 'none'; });
    }
    function itemFor(t) {
      var id = t.getAttribute('data-media-id');
      if (t.getAttribute('data-kind') === 'clip' && clips[id]) {
        var c = clips[id];
        return { type: 'video', sources: (c.sources || []).map(function (s) { return { src: s.url || s.src, type: s.mime_type || s.type || '' }; }), poster: c.poster || c.thumb || '' };
      }
      var p = photos[id];
      var im = t.querySelector('img');
      return { type: 'image', src: p && p.preview ? p.preview.replace(/([?&])width=\d+/, '$1width=2000') : (im ? im.src : ''), poster: im ? im.src : '' };
    }

    function launch(e) {
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      var thumbs = visibleThumbs();
      if (!thumbs.length) {
        var img = stageEl.querySelector('img');
        if (!img) return;
        open({ items: [{ type: 'image', src: img.currentSrc || img.src }], index: 0, origin: function () { return mainBox; } });
        return;
      }
      var active = thumbs.findIndex(function (t) { return t.classList.contains('is-active'); });
      if (active < 0) active = 0;
      // A 3D model slide opens the full-screen 3D viewer (product-model.js) instead
      var am = photos[thumbs[active].getAttribute('data-media-id')];
      if (am && am.kind === 'model' && am.src && window.AgModel3D) {
        window.AgModel3D.open({ src: am.src, poster: am.preview, alt: am.alt });
        return;
      }
      var items = thumbs.map(itemFor);
      var stageVid = stageEl.querySelector('video');
      var startAt = stageVid && items[active].type === 'video' ? stageVid.currentTime : 0;
      if (stageVid) stageVid.pause();
      open({
        items: items, index: active, startAt: startAt,
        origin: function () { return mainBox; },
        onClose: function (n) { if (n !== active && thumbs[n]) thumbs[n].click(); },
        afterClose: function () { var v = stageEl.querySelector('video'); if (v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } }
      });
    }
    // Capture phase, so the builder's own lightbox does not also open.
    stageEl.addEventListener('click', function (e) {
      if (e.target.closest('[data-agpb-nav], .agpb__viewBundle, .agm3d__open')) return;
      launch(e);
    }, true);
    var zoomBtn = root.querySelector('[data-agpb-zoom]');
    if (zoomBtn) zoomBtn.addEventListener('click', launch, true);
  }

  function boot() {
    if (window.Shopify && window.Shopify.designMode) return;
    document.querySelectorAll('[data-siax]').forEach(initRow);
    document.querySelectorAll('[data-agzoom-gallery]').forEach(initGallery);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  // The builder weaves clip thumbs in after load; nothing to re-init, items are read at tap time.
})();
